<template>
    <div class="m-view__box">
        <team/>
        <pay/>
        <sign/>
        <weapon/>
    </div>
</template>

<script>
import team from './team.vue'
import pay from './pay.vue'
import sign from './sign.vue'
import weapon from './weapon.vue'

export default {
    components: {
        team,
        pay,
        sign,
        weapon,
    },      
}
</script>